export function getLevelName(levelString) {
    const level = parseInt(levelString);
    if (level <= 0 || level > 4) {
        return "None";
    }

    switch (level) {
        case 1:
            return "Admin";
        case 2:
            return "Accounts";
        case 3:
            return "BackEnd";
        case 4:
            return "Stock"
        case 5:
            return "RMA"
        default:
            return "Sales";
    }
}
